/**
 * @desc 导出季度计划概览
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanQuarterExportOverviewRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/plan/quarter/exportPlanOverview',
    data,
  });
}

export function mock(
  data: defs.PlanQuarterExportOverviewRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/plan/quarter/exportPlanOverview',
    data,
  });
}
